import React, { useEffect, useState, useRef } from 'react'
import { Box } from '@mui/material'
import domtoimage from 'dom-to-image'
// import { useParams } from 'react-router-dom'
import { CONST_API_NODEJS_URL, CONST_API_NODEJS_URL_PROD } from '../../../../constants'
import { pxToInch, calc } from '../../../../pages/reportsPpt/commonFunctions'
import ProjectsService from '../../../../services/projects.service'
import { useGlobalStore } from '../../../../store'
import { getObjectAsArray, getLogData, timeStampToDate, removeHtmlTags, decodeAndStrip, fakeDelay } from '../../../../util'
import { ExportInfoToolTip } from './styles'

const ExportToPptWithNode = ({ isDownloading, setDownloading, checkIsDownloadingFunc}) => {
  const [checkStatus, setCheckStatus] = useState('stop')
  const [pptFileName, setPptFileName] = useState(null)
  const [pptToolTipValues, setPptToolTipValues] = useState(null)
  const [pptData, setPptData] = useState(null)

  const {
      pptSubLhs,
      setPPTSubLhs,
      pptSubLhsAppendices,
      setPPTSubLhsAppendices,
      pptSubLhsProgression,
      setPPTSubLhsProgression,
      setPPTModalActive,
      setPPTModalActiveAndClicked,
      setPptIdsType,
      exportToPptObject,
      projectIdValue,
    } = useGlobalStore()

  const { IsFreezed } = projectIdValue
  
  const isCustomImage__ethnographyPieBarChartIds = [
    // AMAZON
    '9d0c623b-b2de-11ed-817c-0a1ea4c5532f',
    '5e95d366-6bf1-11ee-817c-0a1ea4c5532f',
    '63357b94-b2da-11ee-9f55-0a1ea4c5532f',
    '70a2369b-fafb-11ee-8482-128e718ba88f',
    'ee0f401e-424d-11ef-8482-128e718ba88f',
    '2e0c6172-882b-11ef-8482-128e718ba88f',
    '00365fa2-53c5-4639-b6df-cd19d5961109',
    // MAHINDRA
    '2a887346-722b-11ef-8482-128e718ba88f',
  ]

  const singleImageArray = [
    'BrandHealthSetup', 'CategoryExplorationSetup', 'ProductRatingOptimizationSetup', 'BrandMagnetScore', 'BrandMagnetScoreAndProgression', 'ImpactDestinations', 'ImpactDestinationsAndProgression',
    'BrandCategoryOverview', 'BrandCategoryOverviewAndProgression', 'CampaignSegmentsEngagementOverview', 'CampaignSegmentsEngagementProgression',
    'BrandImageryMappingTable', 'BrandAttributeMapElement', 'BrandAttributeMapAndProgression',
    'Triangulation', 'TriangulationComparisonViewOnly', 'TriangulationMapElement', 'TriangulationMapAndProgression', 'TriangulationMapElementLog10', 'TriangulationMapAndProgressionLog10',
    'BuzzMetrics', 'CampaignAndIssuesAssessmentSetup',
  ]
  const multipleImageObject = [
    {type:'CustomImage', selector:'.customImageRow'},
    {type:'Snapshot', selector:'.snapshotRow'},
    {type:'BrandImageryMappingAndProgressionGraph', selector:'.brandImageryRowImg'},
    {type:'BrandImageryMappingGraph', selector:'.brandImageryRowImg'},
    {type:'InsightsMiningFrameworkWithoutSentiments', selector:'.segmentRow'},
    {type:'CampaignTriggers', selector:'.pptSectionWrap'},
    {type:'MultiBrandNPS', selector:'.barWrapper'},
    {type:'DriversProgression', selector:'.segmentRows'},
    {type:'SearchDriversProgression', selector:'.segmentRows'},
    {type:'DriversProgressionWithoutSentiments', selector:'.segmentRows'},
    {type:'CategoryPersona', selector:'.segmentChild'},
    {type:'DriversProgression3Level', selector:'.segmentRows'},
    {type:'SearchDriversProgression3Level', selector:'.segmentRows'},
    {type:'DriversProgressionWithoutSentiments3Level', selector:'.segmentRows'},
  ]
  const multipleImageArray = multipleImageObject.map(d => d.type)
  const rteArray = [ 'Recommendation', 'RecommendationAndProgression', 'CustomTable', 'BusinessObjective' ]

  const localStorageKey = 'downloadPptFileDetails'

  async function downloadFile(url, fileName) {
    if((localStorage.getItem('blobUrl') === null || localStorage.getItem('blobUrl') === undefined) && localStorage.getItem(localStorageKey)){
      const response = await fetch(url);
      if (!response.ok) throw new Error("Download failed");
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      localStorage.setItem('blobUrl', blobUrl);
      
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      if(localStorage.getItem(localStorageKey)){
        link.click();
      }

      URL.revokeObjectURL(blobUrl); // clean up
    }
  }

  const getPptStatus = (fileName) => {
    setPptToolTipValues([0,50])

    fetch(`${CONST_API_NODEJS_URL}/status`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fileName: fileName }),
    })
      .then((response) => {
        // 1. Check if the network request itself failed
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        // 2. Parse the JSON response body
        return response.json();
      })
      .then( async(data) => {
        
        if (data?.fileExists && localStorage.getItem(localStorageKey)) {
          await fakeDelay(25000);
          console.log('PPT generation completed. Preparing download...');
          
          const fullDownloadUrl = CONST_API_NODEJS_URL + data.downloadUrl + ".pptx";
          setPptToolTipValues([10,10])

          await downloadFile(fullDownloadUrl, data.fileName);
          localStorage.removeItem(localStorageKey);
          
          await fakeDelay(1000)
          window.location.reload();

        } else {
          if (data.status === 'processing') {
              const pendingCount = data.processLog ? data.processLog.pending.length : '...';
              const totalElements = data.processLog ? (data.processLog.completed.length + data.processLog.pending.length + data.processLog.errors.length) : '...';
              setPptToolTipValues([totalElements-pendingCount,totalElements])
          } else if (data.status === 'completed_with_errors') {
          } else if (data.status === 'pending') {
          }

          setTimeout(() => { getPptStatusFunc() }, 3000)
        }
      })
      .catch( async(error) => {
        console.error('Error:', error);

        setPptToolTipValues([10,10])
        localStorage.removeItem(localStorageKey);
        console.log('The PPT generation has failed. Please try again later.')
        await fakeDelay(1000)
        // document.body.removeChild(link);
        window.location.reload();
      });
  }

  
  function normalizeHtml(str) {
    // remove &nbsp;
    str = str.replace(/&nbsp;/g, '');

    // remove newlines
    str = str.replace(/\n/g, '');

    // remove empty tags like <p></p> or <p>   </p>
    str = str.replace(/<([a-z][a-z0-9]*)\b[^>]*>\s*<\/\1>/gi, '');

    str = str.replaceAll('<div>', '').replaceAll('</div>', '');

    // wrap with a single div
    return `<div>${str}</div>`;
  }

  // Mark the top-level function async
  const getData = async (exportToPptObject, pptData) => {
    const data = pptData
    let hitApi = true
    const studyId = data[0].StudyId;
    const projectIdValueTemp = getLogData('GetStudies', 'GetStudies', {}, { StudyId: studyId })[0];

    try {
      const resp = await ProjectsService.projectsDetailApi({ projectId: projectIdValueTemp.ProjectId }, true);
      const obj = getObjectAsArray(resp).find(f => f.StudyId === studyId);
      
      const headerLogData = obj.ProjectId
        ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: obj.ProjectId })[0]
        : {};

      const headerObj = {
        studyId: obj.StudyId,
        breadCrumb: headerLogData.ProjectType,
        title: `${headerLogData.BrandName || headerLogData.CategoryName} ${headerLogData.ProjectType}`,
        subTitle: `${headerLogData.MarketName} | ${obj.Period}`,
        lastUpdated: timeStampToDate(headerLogData.ModifiedDate),
        studyTitle: `${headerLogData.BrandName || headerLogData.CategoryName}`,
        studySubTitle: `${headerLogData.ProjectType}, ${headerLogData.MarketName}`,
      }

      // localStorage.removeItem(localStorageKey);
      await fakeDelay(300)
      // Process items sequentially: keep awaits and allow early exit when RTE value is missing.
      const finalData = [];
      let hitApi = true;

      // PHASE 2 (Moved to Start): DOM Parsing & Insights Processing
      // We map the initial data to get the Insights and IDs ready for the DOM
      const preparedItems = data.map(d => {
        const insightsData = d?.Insights?.replaceAll('\n', '') || null;
        const cleanedInsights = insightsData ? normalizeHtml(insightsData) : null;
        const id = `${d.InsightsElementType}__${d.InsightsElementId.replaceAll('-', '_')}`;
        return { ...d, cleanedInsights, id };
      })

      for (let item of preparedItems) {
        let insightsPPT = null;

        if (item.cleanedInsights) {
          const newDiv = document.createElement("div");
          newDiv.id = "reportHeadingRteInsights__" + item.id;
          newDiv.innerHTML = item.cleanedInsights;
          document.body.appendChild(newDiv);

          // Wait for DOM rendering
          await fakeDelay(500);

          const id_headingInsight = document.getElementById("reportHeadingRteInsights__" + item.id);
          
          insightsPPT = id_headingInsight?.childNodes
            ? await nodeJsonFunc(id_headingInsight.childNodes, 'jsonObject_headingInsights')
            : null;

          newDiv.remove();
        }
        item.InsightsPPT = insightsPPT;
      }

      // PHASE 1: Image Conversion & Final Object Construction
      for (let idx = 0; idx < preparedItems.length; idx++) {
        const d = preparedItems[idx];
        let base64 = null;
        let pptData = null;

        // Image/RTE logic
        if (singleImageArray.includes(d.InsightsElementType)) {
          base64 = await convertSingleImageToBase64(d);
        } else if (['CustomImage'].includes(d.InsightsElementType) && !isCustomImage__ethnographyPieBarChartIds.includes(d.InsightsElementId)) {
          await fakeDelay(5000);
          base64 = await convertSingleImageToBase64(d);
          // const selectorObj = multipleImageObject.find(f => f.type === d.InsightsElementType);
          // base64 = await convertMultiImageToBase64WithDims({ d: d, ...selectorObj, type:'jpeg' });
        } else if (['BrandImageryMappingAndProgressionGraph', 'BrandImageryMappingGraph'].includes(d.InsightsElementType)) {
          const selectorObj = multipleImageObject.find(f => f.type === d.InsightsElementType);
          const imgType = ['BrandImageryMappingAndProgressionGraph', 'BrandImageryMappingGraph'].includes(d.InsightsElementType) ? 'png' : 'jpeg'
          await fakeDelay(1000)
          base64 = await convertMultiImageToBase64WithDims({ d: d, ...selectorObj, type:imgType });
        } else if (multipleImageArray.includes(d.InsightsElementType)) {
          const selectorObj = multipleImageObject.find(f => f.type === d.InsightsElementType);
          base64 = await convertMultiImageToBase64WithDims({ d: d, ...selectorObj, type:'jpeg' });
        } else if (rteArray.includes(d.InsightsElementType)) {
          const val = exportToPptObject?.[d.id];
          if (val === undefined) {
            hitApi = false;
            break; 
          }
          pptData = val;
        }

        const obj = {
          StudyId: d.StudyId,
          TabId: d.TabId,
          InsightsElementId: d.InsightsElementId,
          EntityId: d.EntityId,
          InsightsElementType: d.InsightsElementType,
          Title: d.Title,
          ParentTitle: d.ParentTitle,
          Heading: decodeAndStrip(d.Heading),
          Insights: d.cleanedInsights,
          InsightsPPT: d.InsightsPPT,
          Observations: d.Observations,
          InsightsElementOrder: d.InsightsElementOrder,
          id: d.id,
          base64: base64,
          pptData: pptData,
          isAppendices: pptSubLhsAppendices?.length > 0,
          isProgression: pptSubLhsProgression?.length > 0,
          isFreezed: IsFreezed
        };

        finalData.push(obj);
      }

      if (hitApi === false) return false;

      const logoDetails = {
        big:{
          logoImg: document.getElementById('downloadLogoBig').getAttribute('src'),
          logoImgBase64: await convertSingleImageToBase64(null, 'downloadLogoBig', 'png'),
          logoH: parseInt(document.getElementById('downloadLogoBig').height),
          logoW: parseInt(document.getElementById('downloadLogoBig').width)
        },
        small:{
          logoImg: document.getElementById('downloadLogoSmall').getAttribute('src'),
          logoImgBase64: await convertSingleImageToBase64(null, 'downloadLogoSmall', 'png'),
          logoH: parseInt(document.getElementById('downloadLogoSmall').height),
          logoW: parseInt(document.getElementById('downloadLogoSmall').width)
        }
      }
      const clientLogoDetails = {
        big:{
          path: logoDetails.big.logoImgBase64,
          w: pxToInch(logoDetails.big.logoW),
          h: pxToInch(logoDetails.big.logoH),
        },
        small:{
          path: logoDetails.small.logoImgBase64,
          w: pxToInch(logoDetails.small.logoW),
          h: pxToInch(logoDetails.small.logoH),
        }
      };

      const props = {
        title: headerObj.title,
        subTitle: headerObj.subTitle,
        lastUpdated: headerObj.lastUpdated,
        logoDetails: clientLogoDetails,
        studyDetails: headerObj,
        isFreezed: IsFreezed
      };

      const fileName = `Study_${(props.studyDetails?.studyTitle).replaceAll(' ','')}_${props.studyDetails.breadCrumb.replaceAll(' ','')}_${props.studyDetails.subTitle.split('|')[1].replaceAll(' ','')}__${Date.now()}`
      const ppptObj = { fileName, method: '', props, payload: finalData };

      // helper: POST with retries
      const postWithRetry = async (url, options, retries = 3, delayMs = 2000) => {
        let attempt = 0;
        let lastError = null;
        while (attempt < retries) {
          try {
            const res = await fetch(url, options);
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res;
          } catch (err) {
            lastError = err;
            attempt += 1;
            if (attempt < retries) {
              // wait before next retry
              await fakeDelay(delayMs);
            }
          }
        }
        // all attempts failed
        throw lastError;
      };

      // POST and only proceed when the POST succeeded
      const postRes = await postWithRetry(`${CONST_API_NODEJS_URL}/reports`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ppptObj),
      }, 3, 2000);

      if (!postRes || !postRes.ok) {
        // this branch is defensive — postWithRetry already throws on permanent failure,
        // but keep a guard so subsequent code only runs on success.
        throw new Error('Failed to POST ppt payload');
      }

      // Remove all <strong> tags under element with id 'id2' (unwrap while preserving children)
      try {
        const id2El = document.getElementById('id2');
        if (id2El) {
          const strongs = Array.from(id2El.querySelectorAll('strong'));
          strongs.forEach((s) => {
            const parent = s.parentNode;
            if (!parent) return;
            const frag = document.createDocumentFragment();
            while (s.firstChild) frag.appendChild(s.firstChild);
            parent.replaceChild(frag, s);
          });
        }
      } catch (removeErr) {
        console.warn('Failed to remove <strong> tags under id2:', removeErr);
      }

      setPptFileName({fileName: fileName});
      // setCheckStatus('stop');
      // setDownloading(false)

      const removingBase64 = (obj) => {
        const payload = obj.payload.map(d => ({...d, base64:null, pptData:null }))
        return {...obj, payload: payload}
      }
      localStorage.setItem(localStorageKey, JSON.stringify(removingBase64(ppptObj)));
      setTimeout(() => { getPptStatusFunc() }, 1000)

      // RELOADING THE PAGE FOR RESETTING THE VARIABLES
      // window.location.reload();
      
      setPPTModalActive(false)
      setPptIdsType('')
      setPPTSubLhs([])
      setPPTSubLhsAppendices([])
      setPPTSubLhsProgression([])
      setPPTModalActiveAndClicked(false)

    } catch (error) {
      console.error('Error:', error);
      // optionally: setCheckStatus('stop')
      throw error;
    }
  }

  const getPptStatusFunc = () => {
    const raw = pptFileName || JSON.parse(localStorage.getItem(localStorageKey));
    if (raw !== null) {
      checkIsDownloadingFunc()
      try {
          const fileName = raw.fileName;
          getPptStatus(fileName)
      } catch (err) {
        // console.error('Failed to parse '+localStorageKey, err);
      }
    }
  }

  useEffect(() => {
    if(pptSubLhs?.length > 0 && isDownloading){
      setCheckStatus('start')
      setPptData(pptSubLhs)
    }
    if(pptSubLhsAppendices?.length > 0 && isDownloading){
      setCheckStatus('start')
      setPptData(pptSubLhsAppendices)
    }
  }, [pptSubLhs, pptSubLhsAppendices, isDownloading])

  useEffect(() => {
    getPptStatusFunc()
    localStorage.removeItem('blobUrl');
  }, [])

  useEffect(() => {
    if(exportToPptObject && checkStatus === 'start' && pptData?.length > 0){
      getData(exportToPptObject, pptData)
    }
  }, [exportToPptObject, checkStatus, pptData])

  return (
    <Box>
      {pptToolTipValues && <PptToolTip size={20} total={pptToolTipValues[1]} current={pptToolTipValues[0]} />}
    </Box>
  )
}

export default ExportToPptWithNode

const convertSingleImageToBase64 = async (d, elementId=null, type='jpeg', retries = 4, delayMs = 2000) => {
  
  const id = elementId || `${d.InsightsElementType}__${d.InsightsElementId.replaceAll('-', '')}`;
  // attempt counter
  let attempts = 0;

  const wait = (ms) => new Promise((res) => setTimeout(res, ms));
  
  while (attempts < retries) {
    const el = document.querySelector(`#${id}`);
    
    if (el) {
      // if element found, process and return base64
      el.classList.add("exportToPPT");
      if(type === 'jpeg') el.style.setProperty("background", "#FFFFFE", "important");
      
      try {
        const dataUrl = (type === 'png') ? await domtoimage.toPng(el) : await domtoimage.toJpeg(el, { quality: 0.95 });
        return dataUrl;
      } catch (error) {
        console.error("FAILED generating image:", error);
        throw error; // or return null
      }
    }

    // not found → wait and retry
    attempts++;
    console.warn(`Element #${id} not found. Retrying ${attempts}/${retries}…`);
    await wait(delayMs);
  }

  // after all retries
  console.warn(`Element #${id} not found after ${retries} attempts.`);
  return null; // or throw new Error(...)
};


const convertMultiImageToBase64WithDims = async ({ d, selector, type='jpeg' }) => {
  const id = `${d.InsightsElementType}__${d.InsightsElementId.replaceAll('-', '')}`;
  const container = document.querySelector(`#${id}`) || document.querySelector(`#Appendices__${id}`) || document.querySelector(`#Progression__${id}`);

  if (!container) return [];

  if(type === 'jpeg') container.style.setProperty('background', '#FFFFFE', '!important');

  const nodes = container.querySelectorAll(selector);
  const outputs = [];

  let previousY = 0;

  for (const node of nodes) {
    if(node.childNodes.length > 0){
      // get bounding rect BEFORE converting
      const rect = node.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;
      const oldBG = node.style.background;
      const imgAlt = node.getAttribute('title') || ''
    
      if(type === 'jpeg') node.style.background = '#FFFFFE'; // was creating issue in Brand Imageary Mapping
      // export to base64
      const dataUrl = (type === 'png') ? await domtoimage.toPng(node) : await domtoimage.toJpeg(node, { quality: 0.95 });

      // record result. x = 0, y = previousY
      outputs.push({
        image: dataUrl,
        w: width,
        h: height,
        x: 0,
        y: previousY,
        alt: imgAlt
      })

      previousY += height;
      node.style.background = oldBG; // restore
    }
  }

  const finalOutput = outputs.filter(f => f.image.length > 25)
  return finalOutput;
};


const PptToolTip = ({
  size = 50,
  total = 100,
  current = 0,
  strokeWidth = 5,
}) => {
  const radius = (size - strokeWidth) / 2;  
  const circumference = 2 * Math.PI * radius;
  const [percentage, setPercentage] = useState(0);

  const {
    isFullScreen
  } = useGlobalStore()

  useEffect(() => {
    const percent = Math.min(current / total, 1);
    const newOffset = circumference * (1 - percent);
    const pVal = Math.round(percent*100)
    const finalVal = (pVal> 100 ? 100 : pVal)
    setPercentage(Math.max(percentage, finalVal))
  }, [current, total, circumference])

  return (
    <>
      {!isFullScreen && <ExportInfoToolTip>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="15" viewBox="0 0 33 15" fill="none"><path d="M16.0215 0L32.043 15L1.52588e-05 15L16.0215 0Z" fill="black"/></svg>
        {percentage===100 ? 'Packaging report. Few seconds more...' : `Study is being exported (${percentage}%)`}
      </ExportInfoToolTip>}
    </>
  );
};

////////////////////////////////////////
let count = 0

const removeTags = (str) => {
  let data = str

  const replaceArray = [
    '<STRONG>',
    '</STRONG>',
    '<strong>',
    '</strong>',
    '<STRIKE>',
    '</STRIKE>',
    '<strike>',
    '</strike>',
    '<S>',
    '</S>',
    '<s>',
    '</s>',
    '<EM>',
    '</EM>',
    '<em>',
    '</em>',
    '<SUB>',
    '</SUB>',
    '<sub>',
    '</sub>',
    '<SUP>',
    '</SUP>',
    '<sup>',
    '</sup>',
    '<UNDERLINE>',
    '</UNDERLINE>',
    '<underline>',
    '</underline>',
  ]
  if (typeof data === 'string') {
    data = str.split('<ul>')[0]
    data = data.replaceAll('<sup>TM</sup>', ' ').replaceAll('<SUP>TM</SUP>', ' ')
    for (let r = 0; r < replaceArray.length; r++) {
      data = data.replaceAll(replaceArray[r], '')
    }
    data = data
      .replaceAll('<BR />', ' ')
      .replaceAll('<br />', ' ')
      .replaceAll('<BR>', ' ')
      .replaceAll('<br>', ' ')
    data = data
      .replaceAll('&nbsp;', ' ')
      .replaceAll('&amp;', '&')
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '\/')
      .replaceAll('&apos;', "'")
    data = data
      .replace(/<\/?span[^>]*>/g, '')
      .replace(/<\/?div[^>]*>/g, '')
      .replace(/<\/?p[^>]*>/g, '')
  }
  return data
}

const nodeJsonFunc = async (nodes, parentNode) => {
  let obj = {}
  try {
    if (
      ['UL', 'OL', 'ULUL', 'OLOL', 'ULULUL', 'OLOLOL', 'ULULULUL', 'OLOLOLOL', 'ULULULULUL', 'OLOLOLOLOL', 'ULULULULULUL', 'OLOLOLOLOLOL'].includes(parentNode)
    ) {
      obj = []
    }
    for (let i = 0; i < nodes.length; i++) {
      const loopNode = nodes[i]
      let tag = loopNode.nodeName
      if (tag === 'DIV') {
        const txt = loopNode?.childNodes[0]?.nodeValue
        if (txt?.trim().length !== 0) {
          count++
          obj[tag + count] = {
            tag: tag,
            text: txt,
                content:
              loopNode?.childNodes?.length > 0
                ? [await nodeJsonFunc(loopNode.childNodes, tag)]
                : [],
          }
        }
      }
      if (tag === 'UL') {
        count++
        const tagNew =
          parentNode === 'LILILILILI'
            ? 'ULULULULULUL'
            : parentNode === 'LILILILI'
              ? 'ULULULULUL'
              : parentNode === 'LILILI'
                ? 'ULULULUL'
                : parentNode === 'LILI'
                  ? 'ULULUL'
                  : parentNode === 'LI'
                    ? 'ULUL'
                    : tag
        obj[tag + count] = {
          tag: tagNew,
          content:
            loopNode?.childNodes?.length > 0 ? await nodeJsonFunc(loopNode.childNodes, tagNew) : [],
        }
      }
      if (tag === 'LI') {
        const txt = removeTags(loopNode.innerHTML)
        if (txt?.trim().length !== 0) {
          const tagNew =
            (parentNode === 'ULULULULULUL' || parentNode === 'OLOLOLOLOLOL')
              ? 'LILILILILILI'
              : (parentNode === 'ULULULULUL' || parentNode === 'OLOLOLOLOL')
                ? 'LILILILILI'
                : (parentNode === 'ULULULUL' || parentNode === 'OLOLOLOL')
                  ? 'LILILILI'
                  : (parentNode === 'ULULUL' || parentNode === 'OLOLOL')
                    ? 'LILILI'
                    : (parentNode === 'ULUL' || parentNode === 'OLOL')
                      ? 'LILI'
                      : tag
          const txt2 = txt
          obj.push({
            tag: tagNew,
            text: txt,
            content:
                loopNode?.childNodes?.length > 1
                  ? await nodeJsonFunc(loopNode.childNodes, tagNew)
                  : '',
          })
        }
      }
      if (tag === 'P') {
        const txt = removeTags(loopNode.innerHTML) + '\n'
        if (txt?.trim().length !== 0) {
          count++
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content: '',
          }
        }
      }
      if (tag === 'H4') {
        const txt = removeTags(loopNode.innerHTML) + '\n'
        if (txt?.trim().length !== 0) {
          count++
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content: '',
          }
        }
      }
      if (tag === 'HR') {
        count++
        obj[tag + count] = {
          tag: tag,
          text: '',
          content: '',
        }
      }
    }
  } catch (error) {
    console.log('TCF 2 > Error --------- ', error)
  }
  return obj
}

